import { Alert, Grid } from "@arco-design/web-react";

const { Row, Col } = Grid;

// MUI -> Arco. Grid -> Arco Grid (/12 -> /24); Alert -> Arco Alert (type/
// content). contentStyle is now a style object applied via `style`.
export default function TextViewer(props) {
    const { textContent, contentStyle } = props;

    return (
        <Row>
            <Col span={24}>
                <Alert type="info" content="Some recipients use email clients that only support TEXT, this is what they'll see." />
            </Col>
            <Col span={24}>
                <div style={contentStyle} ><pre style={{ overflowX: "auto" }}>{textContent}</pre></div>
            </Col>
        </Row>
    )
}
